module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Error-circle-166ec2a7e09573ac1f4313ae822468a3.svg";